import { render, staticRenderFns } from "./BatteryStatusBar.vue?vue&type=template&id=4bf7462f&scoped=true&"
import script from "./BatteryStatusBar.vue?vue&type=script&lang=ts&"
export * from "./BatteryStatusBar.vue?vue&type=script&lang=ts&"
import style0 from "./BatteryStatusBar.vue?vue&type=style&index=0&id=4bf7462f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7462f",
  null
  
)

export default component.exports